/**
 * Created by Alex Poh. on 19/07/20.
 * Copyright © 2020 Curriculum Ltd. All rights reserved.
 */

import { Observable, ReplaySubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { MathContent } from './math-content';

declare global {
  interface Window {
    MathJax: any;
  }
}

@Injectable()
export class MathServiceImpl {
  private readonly notifier = new ReplaySubject<boolean>(1);

  ready(): Observable<boolean> {
    return this.notifier.asObservable();
  }

  render(element: HTMLElement, math?: MathContent | string): void {
    if (math) {
      if (typeof math === 'string') {
        element.innerHTML = math;
      } else if (math.latex != null) {
        const t = String(math.latex).trim();
        const hasDelims = /(\$[^$]+\$)|\\\(|\\\[|\$\$/.test(t);
        element.textContent = hasDelims ? t : `\\(${t}\\)`;
      } else if ((math as any).mathml) {
        element.innerHTML = String((math as any).mathml);
      } else {
        element.innerHTML = String(math as any ?? '');
      }
    }

    const MJ = (window as any).MathJax;
    if (MJ?.typesetPromise) {
      MJ.typesetPromise([element]).catch((err: any) => {
        console.error('MathJax typeset failed', err);
      });
    }
  }
}
